export default __webpack_public_path__ + "static/media/hours.43725244.svg";